:host {
  overflow: hidden;

  .hide {
    display: none !important;
  }

  .error {
    padding-top: 20px;
  }

  .error-unauthorized-bg {
    background: black;
    opacity: 0.3;
    width: calc(100% + 30px);
    height: calc(100% + 30px);
    position: absolute;
    top: -30px;
    left: -15px;
    z-index: 3;
  }

  .error-unauthorized-messages {
    filter: blur(3px);
    padding: 0 20px;
  }
}
